export const FILTER_QUERY_KEYS = {
  STATE_OPTIONS: 'stateOptions',
  CLIENT_OPTIONS: 'clientOptions',
  SEGMENT_OPTIONS: 'segmentOptions',
  ASSIGNEE_OPTIONS: 'assigneeOptions',
  PROJECT_OPTIONS: 'projectOptions',
  PROJECT_BY_ID: 'projectById',
} as const;

export const PROJECT_DASHBOARD_KEYS = {
  GET_PROJECT_DASHBOARD: 'get_project_dashboard',
};

export const BUDGET_STATUS_KEYS = {
  GET_TASKS: 'get_budget_status_tasks',
  GET_COST_CENTRES: 'get_budget_status_cost_centres',
};
